import React, { useState, useEffect } from 'react';
import './GrafanaEmbed.css';

const REMOTE = 'http://13.222.36.176:3000';
const DASHBOARD_UID = 'afgvi0y6x6sqof';
const TIME_RANGE = 'from=2026-03-01T00:00:00Z&to=2026-03-31T23:59:59Z&timezone=browser&refresh=10s';

const PANELS = [
  { id: 1,  title: '💧 WaterTank Volume 1',       type: 'stat',       color: '#00d4ff' },
  { id: 2,  title: '💧 WaterTank Volume 2',       type: 'stat',       color: '#00d4ff' },
  { id: 3,  title: '🌊 Flow Rate 1',              type: 'stat',       color: '#34d399' },
  { id: 4,  title: '🌊 Flow Rate 2',              type: 'stat',       color: '#34d399' },
  { id: 5,  title: '📈 WaterTank Volume Over Time', type: 'timeseries', color: '#a78bfa' },
  { id: 6,  title: '📈 Flow Rate Over Time',      type: 'timeseries', color: '#fbbf24' },
  { id: 7,  title: '🔵 Tank Volume 1 Gauge',      type: 'gauge',      color: '#60a5fa' },
  { id: 8,  title: '🔴 Flow Rate 1 Gauge',        type: 'gauge',      color: '#f87171' },
  { id: 9,  title: '📊 All Properties Comparison', type: 'barchart',   color: '#f97316' },
];

const PANEL_ICONS: Record<string, string> = {
  stat: '🔢', timeseries: '📈', gauge: '🎯', barchart: '📊',
};

const GrafanaEmbed: React.FC = () => {
  const [health, setHealth] = useState<'checking' | 'online' | 'offline'>('checking');
  const [embedAllowed, setEmbedAllowed] = useState(false);
  const [activePanel, setActivePanel] = useState<number | null>(null);

  const dashboardUrl = `${REMOTE}/d/${DASHBOARD_UID}/cookiefactory-digital-twin?orgId=1&${TIME_RANGE}`;

  useEffect(() => {
    fetch(`${REMOTE}/api/health`, { mode: 'no-cors' })
      .then(() => setHealth('online'))
      .catch(() => setHealth('offline'));
  }, []);

  const panelUrl = (id: number) =>
    `${REMOTE}/d-solo/${DASHBOARD_UID}/cookiefactory-digital-twin?orgId=1&panelId=${id}&${TIME_RANGE}&kiosk`;

  return (
    <div className="grafana-page">
      <div className="page-header">
        <h1>📊 Grafana Dashboard</h1>
        <span className={health === 'online' ? 'badge-green' : health === 'offline' ? 'badge-red' : 'badge-yellow'}>
          {health === 'online' ? '● Online' : health === 'offline' ? '● Offline' : '⏳ Checking'}
        </span>
        <a href={dashboardUrl} target="_blank" rel="noreferrer" className="btn-primary" style={{ marginLeft: 'auto', fontSize: 14 }}>
          🚀 Open Full Dashboard ↗
        </a>
      </div>

      {/* Embed fix notice */}
      <div className="embed-notice card">
        <div className="notice-icon">ℹ️</div>
        <div className="notice-body">
          <strong>Grafana iframe embedding is disabled by default.</strong>
          <span> To enable it, add <code>allow_embedding = true</code> to <code>grafana.ini</code> under <code>[security]</code> on the remote server, then restart Grafana.</span>
        </div>
        <button className="btn-secondary" style={{ fontSize: 13 }} onClick={() => setEmbedAllowed(e => !e)}>
          {embedAllowed ? 'Hide iframes' : 'Try anyway'}
        </button>
      </div>

      {/* Panel Grid */}
      <div className="panels-grid">
        {PANELS.map(p => (
          <div key={p.id} className={`panel-card card ${activePanel === p.id ? 'active' : ''}`}
            onClick={() => setActivePanel(activePanel === p.id ? null : p.id)}>
            <div className="panel-header">
              <span className="panel-type-icon">{PANEL_ICONS[p.type]}</span>
              <span className="panel-title">{p.title}</span>
              <span className="panel-type-badge" style={{ color: p.color }}>{p.type}</span>
            </div>

            {/* iframe shown only if embedAllowed or user clicked "Try anyway" */}
            {embedAllowed && activePanel === p.id && (
              <div className="panel-iframe-wrap">
                <iframe
                  src={panelUrl(p.id)}
                  title={p.title}
                  className="panel-iframe"
                  sandbox="allow-scripts allow-same-origin allow-forms"
                />
              </div>
            )}

            {!embedAllowed && (
              <div className="panel-actions">
                <a href={panelUrl(p.id)} target="_blank" rel="noreferrer" className="panel-link"
                  onClick={e => e.stopPropagation()}>
                  Open Panel ↗
                </a>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Quick access */}
      <div className="grafana-links card" style={{ marginTop: 24 }}>
        <h3 style={{ marginBottom: 16 }}>🔗 Quick Access</h3>
        <div className="links-row">
          {[
            { label: '📊 Full Dashboard',     url: dashboardUrl },
            { label: '🔑 Login (jyothika)',    url: `${REMOTE}/login` },
            { label: '⚙️ Data Sources',        url: `${REMOTE}/datasources` },
            { label: '📁 CookieFactory Folder', url: `${REMOTE}/dashboards/f/8/cookiefactory` },
          ].map(l => (
            <a key={l.label} href={l.url} target="_blank" rel="noreferrer" className="quick-link card">
              {l.label} ↗
            </a>
          ))}
        </div>

        <div className="enable-embed-box">
          <h4>🛠️ Enable iframe embedding on remote Grafana</h4>
          <p>SSH into the EC2 instance and run:</p>
          <pre>{`# Edit grafana.ini
sudo nano /etc/grafana/grafana.ini

# Under [security] section add:
allow_embedding = true

# Restart Grafana
sudo systemctl restart grafana-server`}</pre>
        </div>
      </div>
    </div>
  );
};

export default GrafanaEmbed;
